<template>
  <PlanSummaryCardText
    :showCouponBadge="hasAppliedCoupon"
    :title="planSummaryTitle"
    :pricing="planPricing"
    :strikethroughPricing="strikethroughPricing"
    :subheading="subheading"
    :secondarySubheading="pricingSubheading"
    :trialInfo="trialDisplay"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import PlanSummaryCardText from './PlanSummaryCardText.vue'
import { useCheckoutStore } from '@/store/CheckoutStore'
import { useCouponStore } from '@/store/CouponStore'
import { usePlanStore } from '@/store/PlanStore'
import { usePriceStore } from '@/store/PriceStore'
import { useProductStore } from '@/store/ProductStore'
import { useTrialStatus } from '@/composables/useTrialStatus'
const checkoutStore = useCheckoutStore()
const planStore = usePlanStore()
const priceStore = usePriceStore()
const productStore = useProductStore()
const couponStore = useCouponStore()
const { country } = storeToRefs(checkoutStore)
const { name: productName } = storeToRefs(productStore)
const { selectedPlanDisplayPrice, selectedPlanDisplayUnitPrice } = storeToRefs(priceStore)

const { selectedPlanIntervalAsNoun, selectedPlanTrialLengthDisplay, selectedPlanLengthDisplay } = storeToRefs(planStore)
const { planHasTrial } = useTrialStatus()

const { hasAppliedCoupon, couponDuration, isTemporalCoupon, isForeverCoupon, isSingleUseDiscountCoupon, isFreeTrialCoupon, appliedCouponTrialLength } =
  storeToRefs(couponStore)

const preTaxDetails = computed(() => (country.value === 'US' ? '(pre-tax)' : ''))

const planSummaryTitle = computed(() => productName.value)
const subheading = computed(() => `${trialEmailDisplay.value} Cancel anytime.`)

const strikethroughPricing = computed(() => selectedPlanDisplayUnitPrice.value)
const planPricing = computed(() => `${selectedPlanDisplayPrice.value}/${selectedPlanIntervalAsNoun.value} ${preTaxDetails.value} ${durationDisplay.value}`)

const duration = computed(() => {
  if (isTemporalCoupon.value) {
    return couponDuration.value
  } else if (isSingleUseDiscountCoupon.value) {
    return selectedPlanLengthDisplay.value
  }
  return ''
})

const pricingSubheading = computed(
  () => `${selectedPlanDisplayUnitPrice.value}/${selectedPlanIntervalAsNoun.value} ${preTaxDetails.value} ${subheadingDurationDisplay.value}`
)
const subheadingDurationDisplay = computed(() => (isForeverCoupon.value ? '' : `after ${duration.value}`))
const durationDisplay = computed(() => (isForeverCoupon.value ? '' : `for ${duration.value}`))

const trialLengthDisplay = computed(() => (isFreeTrialCoupon.value ? appliedCouponTrialLength.value : selectedPlanTrialLengthDisplay.value))
const trialDisplay = computed(() => (planHasTrial.value ? `after a ${trialLengthDisplay.value} trial.` : 'starting today.'))
const trialEmailDisplay = computed(() => (planHasTrial.value ? trialEmailNotice : ''))
const trialEmailNotice = "We'll remind you three days before your trial ends."
</script>
